<template>
    <div style="width: 100%; height: 100%">
        <!-- <div style="width: 300px; margin: 0 auto; padding: 20px 0 0 0">
            <a
                target="_blank"
                href="https://beian.miit.gov.cn/#/Integrated/index"
                style="
                    display: inline-block;
                    text-decoration: none;
                    height: 20px;
                    line-height: 20px;
                "
            >
                <p
                    style="
                        float: left;
                        height: 20px;
                        line-height: 20px;
                        margin: 0px 0px 0px 5px;
                        color: #939393;
                    "
                >
                    蜀ICP备2021019742号-4
                </p>
            </a>
        </div> -->
    </div>
</template>

<script>
export default {
    name: "foot",
};
</script>

<style scoped>
a {
    color: #fff;
    text-underline: none;
}
</style>
